<template>
  <div class="search">
    <template v-if="number">
      <input
        ref="input"
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        v-model="model"
        :placeholder="placeholder"
      />
    </template>
    <template v-else>
      <input ref="input" v-model="model" :placeholder="placeholder" />
    </template>
    <div @click="clear()" class="icon">
      <ux-icon :icon="icon" />
    </div>
  </div>
</template>
<script>
import _debounce from "lodash/debounce";

export default {
  props: {
    number: {
      type: Boolean,
    },
    autofocus: {
      type: Boolean,
    },
    modelValue: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    debounce: {
      type: Number,
      default() {
        return 500;
      },
    },
    loading: {
      type: Boolean,
    },
  },
  mounted() {
    var self = this;
    self.dispatch = _debounce(() => {
      self.$emit("update:modelValue", self.value);
    }, self.debounce);

    if (self.autofocus) {
      self.$refs.input.focus();
    }
  },
  activated() {
    var self = this;
    if (self.autofocus) {
      self.$refs.input.focus();
    }
  },
  data() {
    return {
      value: String(this.modelValue),
    };
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    },
    clear() {
      this.value = "";
      this.$emit("update:modelValue", this.value);
    },
  },
  watch: {
    modelValue(val, old) {
      this.value = val;
    },
  },
  computed: {
    icon() {
      return this.loading
        ? `fa-spinner fa-spin`
        : this.value
          ? `fa-times`
          : `fa-search`;
    },
    selectableOptions() {
      return this.options.map(function (option) {
        const value = option.value || option;
        const label = option.title || option.name || option.label || value;

        return {
          label,
          value,
        };
      });
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.value = value;
        this.dispatch();
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.search {
  position: relative;
  width: 100%;

  & > .icon {
    position: absolute;
    right: 0;
    top: 50%;
    translate: 0 -50%;
    bottom: 0;
    // line-height: 3em;
    padding: 0 1em;
  }

  input {
    width: 100%;
    border-radius: 5em;
    padding: 0.5em 1em;
    box-sizing: border-box;
    // background: rgba(#000, 0.05);
    // border: 1px solid transparent;
    font-size: inherit;
    appearance: none;
    line-height: 1;
    // height:3em;
    // height: 2.5em;
    color: inherit;
    background: color-mix(in lab, currentColor 6%, transparent);
    border: 1px solid transparent;

    &:focus {
      background: var(--bg1, #fff);
      border: 1px solid var(--primary);
      outline: none;
    }
  }
}
</style>
